//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debounce from 'lodash/debounce'
import find from 'lodash/find'
import merge from 'lodash/merge'
import { mapActions, mapGetters, createNamespacedHelpers } from 'vuex'
import PDP from '@/scripts/libs/pdp'
const { mapGetters: mapGettersPdp, mapActions: mapActionsPdp } = createNamespacedHelpers('pdp')

import RbRoxPanel from '@/elements/rox-panel/rb-rox-panel.vue'
import RbLoginPanelAndModal from '@/elements/login-register/rb-login-panel-and-modal.vue'

const { mapActions: mapActionsFrameGenius, mapGetters: mapGettersFrameGenius } =
  createNamespacedHelpers('frameGenius')

import {
  getProfileData,
  loadProductsByPartNumber,
  saveProfileData,
} from '@/scripts/libs/wcs/frame-genius'
import {
  mapApiStore,
  openRoxLensPanel,
  normalizeProductForWhiteLabel,
  mapRxcConfig,
  getLocaleByStoreId,
} from '@/scripts/libs/frame-genius'
import { ENDPOINT_NAME } from '@/scripts/constants/frame-advisor'
import { PANEL_Z_INDEX } from '@/scripts/constants/panel'

import { FrameAdvisor } from '@/scripts/libs/frame-advisor'

import wcs from '@/scripts/libs/wcs'
import { RB } from '@/scripts/constants/store'
import {
  ACTION_ADD_TO_BAG,
  ACTION_ADD_TO_WISHLIST,
  ACTION_LOAD_MINIWISHLIST,
  ACTION_REMOVE_FROM_WISHLIST,
} from '@/scripts/store/actions'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { ACTION_SET_RXC_SCRIPTS_STATUS, ACTION_TOGGLE_ROX_PANEL } from '@/scripts/store/actions/pdp'
import {
  ACTION_SET_FRAME_ADVISOR_SCRIPTS_LOADED_STATUS,
  ACTION_SET_FRAME_GENIUS_ANALYSIS_RESULTS,
  ACTION_SET_FRAME_ADVISOR_STATUS,
  ACTION_SET_FRAME_ADVISOR_FLOATING_BUTTON_STATUS,
  ACTION_SET_SIZE_ADVISOR_STATUS,
} from '@/scripts/store/frame-genius/actions'
import { EVENTS } from '@/scripts/constants/css-classes'
import { SizeAdvisor } from '@/scripts/libs/size-advisor'
import { WcsStoreId } from '@/scripts/libs/wcs/types/store-id'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'
import Resources from '@/scripts/libs/resources'
const FRAME_ADVISOR_UPCS = 'frameAdvisorUPCs'
const { locale, storeId, virtualMirror, roxLensPanel, frameGenius } = wcs.getStoreConfig()

export default {
  name: 'rb-frame-advisor',
  components: {
    RbRoxPanel,
    RbLoginPanelAndModal,
  },
  data() {
    return {
      products: [],
      upcs: [],
      loading: false,
      saveProfileCallbackFunction: () => ({}),
      whiteLabelWidget: undefined,
      showRoxLensPanel: false,
      windowInnerHeight: window.innerHeight,
      loginIsVisible: false,
    }
  },
  computed: {
    ...mapGetters(['userLoggedIn', 'wishlistItems']),
    ...mapGettersPdp(['areRxcScriptsLoaded']),
    ...mapGettersFrameGenius(['isFrameAdvisorOpen', 'isSizeAdvisorOpen', 'areScriptsLoaded']),

    frameAdvisorStyle() {
      if (!this.isMobileOrTablet) {
        return {}
      }

      if (!this.loginIsVisible) {
        return {}
      }

      return {
        zIndex: `${PANEL_Z_INDEX - 1}`,
      }
    },
    isFrameAdvisorRunning() {
      return this.isFrameAdvisorOpen
    },
    isMobileOrTablet() {
      return [MOBILE, TABLET].includes(this.$mq)
    },
    isRoxPanelEnabled() {
      return roxLensPanel.isEnabled
    },
    pageSize() {
      return frameGenius.pageSize
    },
    canFloatingButtonBeUsed() {
      return (
        frameGenius.isFloatingButtonFeatureEnabled &&
        FrameAdvisor.wasFrameAdvisorPreviouslyInitialized()
      )
    },
  },
  watch: {
    userLoggedIn(nextVal, oldVal) {
      if (nextVal !== oldVal) {
        this.saveProfileCallbackFunction()
      }
    },
    windowInnerHeight() {
      this.updateVhMainVar()
    },
  },
  mounted() {
    window.externalInvocationMethodMapping.initFrameAdvisor = async () => {
      if (!this.isFrameAdvisorRunning) {
        if (FrameAdvisor.needsReinit() && frameGenius.isFloatingButtonFeatureEnabled) {
          const floatingButton = document.querySelector('.fa__floating-button-button')
          if (floatingButton) {
            floatingButton.click()
          }
        } else {
          this.products = []
          this.loadAndInitWhiteLabel()
        }
      }
    }

    const openAgainFrameAdvisor = FrameAdvisor.needsReinit()
    if (openAgainFrameAdvisor) {
      this.setFloatingButtonStatus(true)
      this.loadAndInitWhiteLabel()
    }
    this.updateVhMainVar()
    this.$nextTick(() => {
      window.addEventListener(EVENTS.RESIZE, debounce(this.updateWindowInnerHeight, 30))
      if (this.$refs['frameadvUi'] && (this.$mq === TABLET || this.$mq === MOBILE)) {
        this.$refs['frameadvUi'].addEventListener(
          EVENTS.SCROLL,
          debounce(this.updateWindowInnerHeight, 30)
        )
      }
    })

    const canStartFrameAdvisor = FrameAdvisor.canStartFrameAdvisor()

    if (canStartFrameAdvisor) {
      window.externalInvocationMethodMapping.initFrameAdvisor()
    }
  },
  beforeDestroy() {
    document.body.removeEventListener('fa-maximize', this.onFaMaximise, false)
    document.body.removeEventListener('fa-minimize', this.onFaMinimise, false)
    document.body.removeEventListener('fa-close', this.onFaClose, false)

    document.body.removeEventListener('sa-maximize', this.onFaMaximise, false)
    document.body.removeEventListener('sa-minimize', this.onFaMinimise, false)
    document.body.removeEventListener('sa-close', this.onFaClose, false)
    window.removeEventListener(EVENTS.RESIZE, debounce(this.updateWindowInnerHeight, 30))
    this.$refs['frameadvUi']?.removeEventListener(
      EVENTS.SCROLL,
      debounce(this.updateWindowInnerHeight, 30)
    )
  },
  methods: {
    ...mapActions({
      addToWishlist: ACTION_ADD_TO_WISHLIST,
      dispatchAddToBag: ACTION_ADD_TO_BAG,
      loadMiniWishlist: ACTION_LOAD_MINIWISHLIST,
      removeFromWishlist: ACTION_REMOVE_FROM_WISHLIST,
    }),
    ...mapActionsFrameGenius({
      setFrameAdvisorStatus: ACTION_SET_FRAME_ADVISOR_STATUS,
      setSizeAdvisorStatus: ACTION_SET_SIZE_ADVISOR_STATUS,
      setFrameGeniusAnalysisResults: ACTION_SET_FRAME_GENIUS_ANALYSIS_RESULTS,
      setLoadedScriptsStatus: ACTION_SET_FRAME_ADVISOR_SCRIPTS_LOADED_STATUS,
      setFloatingButtonStatus: ACTION_SET_FRAME_ADVISOR_FLOATING_BUTTON_STATUS,
    }),
    ...mapActionsPdp({
      setRxcScriptsStatus: ACTION_SET_RXC_SCRIPTS_STATUS,
      openRoxLensPanel: ACTION_TOGGLE_ROX_PANEL,
    }),
    setWhiteLabelStatus(status) {
      this.setFrameAdvisorStatus(status)
    },
    async loadAndInitWhiteLabel() {
      if (!this.areScriptsLoaded) {
        Resources.loadResourcesWithCallback({
          resources: [frameGenius.faCore],
          callback: () => {
            this.setLoadedScriptsStatus(true)

            this.initWhiteLabel()
          },
        })
      } else {
        this.initWhiteLabel()
      }
    },
    async saveFrameSuggestionData() {
      if (this.whiteLabelWidget.getUserData) {
        const userData = await this.whiteLabelWidget.getUserData()
        FrameAdvisor.setAnalysisResults(userData)
        this.setFrameGeniusAnalysisResults(userData)
        SizeAdvisor.setSizeAdivsorPlpToggleStatus(true)
        return userData
      }
    },
    mapWhiteLabelConfig() {
      const facescanRegion = WcsStoreId.mapFacescanRegion(storeId)
      const termsAndConditions = WcsLocales.getTermsAndConditionsLink(locale)
      const privacyPolicy = WcsLocales.getPrivacyPolicyLink(locale)
      const adjustedLocale = getLocaleByStoreId(storeId, locale)
      const frameAdvAPIStore = mapApiStore(locale)
      const startMinimized = FrameAdvisor.needsReinit()
      const homePageURL = wcs.getEndPoint('homePage')
      const frameAdvisorURL = wcs.getEndPoint(ENDPOINT_NAME)

      const config = {
        selector: '#frameadv-ui',
        locale: adjustedLocale,
        facescanSource: 'FASA_RBCOM',
        facescanRegion,
        frameAdvAPICore: 'fa_catalog',
        frameAdvAPIStore: `${RB}@${frameAdvAPIStore}`,
        facescanPrivacy: {
          privacyPolicy,
          termsAndConditions,
          localizationText: '',
        },
        frameAdvKey: virtualMirror.key,
        startMinimized,
        enableSizeAdvisor: frameGenius.isSizeAdvisorEnabled,
        productRequestRowsLimit: this.pageSize,
        enableVideoMode: frameGenius.isVideoModeEnabled,
        links: [
          { text: 'Home', url: homePageURL },
          { text: 'Frame Advisor', url: frameAdvisorURL },
        ],
      }
      return config
    },
    registerCustomSpinnerEvents() {
      document.querySelector('body').addEventListener(
        'fa-loading',
        () => {
          this.loading = true
        },
        false
      )
      document.querySelector('body').addEventListener(
        'fa-loaded',
        () => {
          this.loading = false
        },
        false
      )
    },
    registerWhiteLabelEvents(config) {
      config.resultCallback = async (response) => {
        {
          if (!response?.products?.length) {
            return []
          }
          const whiteLabelProducts = response.products
          const products = await this.resultCallback(whiteLabelProducts)
          const whiteLabelUpcs = whiteLabelProducts.map((product) => product.upc)

          const normalizedProducts = []
          for (const product of products) {
            const normalizedProduct = await normalizeProductForWhiteLabel(product)
            normalizedProducts.push(normalizedProduct)
          }

          const mergedProducts = normalizedProducts
            .filter((product) => whiteLabelUpcs.includes(product.upc))
            .map((product) => {
              const found = whiteLabelProducts.find(
                (whiteLabelProduct) => whiteLabelProduct?.upc === product?.upc
              )
              const mergedProduct = merge(found, product)
              return mergedProduct
            })
          FrameAdvisor.setFrameAdvisorInitializedStatus(true)
          this.saveFrameSuggestionData()

          return mergedProducts
        }
      }
      config.saveProfileDataCallback = (data) => {
        if (!this.userLoggedIn) {
          return new Promise((resolve) => {
            this.saveProfileCallbackFunction = () => {
              saveProfileData(data)
              resolve()
            }
            this.loginIsVisible = true
          })
        } else {
          return saveProfileData(data)
        }
      }
      config.getProfileDataCallback = async () => {
        const profileData = await getProfileData()
        return profileData
      }
      config.saveSessionData = (data) => {
        FrameAdvisor.saveSessionData(data)
      }
      config.getSessionData = () => {
        return FrameAdvisor.getSessionData()
      }
      config.openRXConfigurator = async (product) => {
        if (!this.isRoxPanelEnabled) {
          return
        }
        const rxcProduct = this.products.find((item) => product.upc === item.upc)
        this.showRoxLensPanel = true
        const configObject = mapRxcConfig(rxcProduct)
        if (!this.areRxcScriptsLoaded) {
          Resources.loadResourcesWithCallback({
            resources: [roxLensPanel.rxc],
            callback: () => {
              this.setRxcScriptsStatus(true)
              openRoxLensPanel(configObject)
              this.openRoxLensPanel({
                isRoxPanelRendered: true,
                roxPanelOverlay: true,
                roxPanelOverlayType: rxcProduct.type,
              })
            },
          })
        } else {
          openRoxLensPanel(configObject)
          this.openRoxLensPanel({
            isRoxPanelRendered: true,
            roxPanelOverlay: true,
            roxPanelOverlayType: rxcProduct.type,
          })
        }
      }
      config.addToBagCallback = async (product) => {
        const currentProduct = this.products.find((item) => product.upc === item.upc)

        const promise = new Promise((resolve) => {
          resolve(
            this.dispatchAddToBag({
              catEntry: currentProduct.catEntryId,
              isPickupStore: false,
              isMobile: false,
              redirect: false,
            })
          )
        })

        return await promise
      }
      config.onGoToBag = () => {
        window.location.href = wcs.getEndPoint('shopCartView')
      }
      config.onToggleWishlist = async (product) => {
        if (!this.userLoggedIn) {
          return '-1'
        }
        const productCatEntry = find(
          this.products,
          (item) => item?.upc === product?.upc
        )?.catEntryId

        const itemInWishlist = this.wishlistItems?.find((item) => item?.partnumber === product?.upc)
        if (!itemInWishlist) {
          await this.addToWishlist({ catEntry: productCatEntry, mq: this.$mq })
          return '1'
        }

        await this.removeFromWishlist({
          wishlistItemId: itemInWishlist.catentryId,
          roxSet: itemInWishlist.roxSet,
          configurationId: itemInWishlist.configurationId,
        })
        return '0'
      }
      config.onLogin = () => {
        window.location.href = wcs.getEndPoint('headerLoginUrl')
      }
      config.onBrowseWishlist = () => {
        window.location.href = wcs.getEndPoint('compareWhislistView')
      }
    },
    initWhiteLabel() {
      this.loadMiniWishlist()
      const config = this.mapWhiteLabelConfig()
      this.registerCustomSpinnerEvents()
      this.registerWhiteLabelEvents(config)
      this.whiteLabelWidget = this.renderWhiteLabelApplication(config)
      this.registerFrameGeniusEvents()
      this.whiteLabelWidget.render()
      this.saveFrameSuggestionData()
    },
    renderWhiteLabelApplication(config) {
      if (!FrameAdvisor.needsReinit()) {
        this.setWhiteLabelStatus(true)
        document.body.style.overflow = 'hidden'
        document.getElementsByTagName('html')[0].style.overflow = 'hidden'
      }
      return window.frameAdvisor.FrameAdvisorWidget.new(config)
    },
    async resultCallback(products) {
      this.products = []
      const upcs = products.map((product) => product.upc)
      this.upcs = upcs
      localStorage.setItem(FRAME_ADVISOR_UPCS, this.upcs)
      await this.prepareAndLoadProducts(this.pageSize)
      return this.products
    },
    async prepareAndLoadProducts(pageSize) {
      const upcsToLoad = this.upcs.splice(0, pageSize)
      if (upcsToLoad.length > 0) {
        await this.loadProducts(upcsToLoad, pageSize)
      }
    },
    async loadProducts(upcs, pageSize) {
      this.loading = true
      const products = await loadProductsByPartNumber(upcs)
      this.loading = false
      const adjustedProducts = products?.slice(0, pageSize)
      const sortedProducts = this.sortAdjustedProducts(adjustedProducts, upcs)
      this.products = this.products.concat(sortedProducts)
      if (adjustedProducts.length < pageSize) {
        await this.prepareAndLoadProducts(pageSize - products.length)
      }
    },
    sortAdjustedProducts(adjustedProducts, upcs) {
      adjustedProducts.sort((firstProduct, secondProduct) => {
        const firstProductUpc = firstProduct.upc
        const secondProductUpc = secondProduct.upc
        if (upcs.indexOf(firstProductUpc) != -1 && upcs.indexOf(secondProductUpc) != -1) {
          return upcs.indexOf(firstProductUpc) - upcs.indexOf(secondProductUpc)
        }
        if (firstProduct.moCo < secondProduct.moCo) {
          return -1
        }
        if (firstProduct.moCo > secondProduct.moCo) {
          return 1
        }
        return 0
      })
      return adjustedProducts
    },
    onFaMaximise() {
      if (this.canFloatingButtonBeUsed) {
        FrameAdvisor.setFloatingButtonMinimizedState(false)
        this.setFloatingButtonStatus(false)
      }
      FrameAdvisor.addPictureModeHashPath()
      this.setWhiteLabelStatus(true)
      document.body.style.overflow = 'hidden'
      document.getElementsByTagName('html')[0].style.overflow = 'hidden'
    },
    onFaMinimise() {
      if (this.canFloatingButtonBeUsed) {
        FrameAdvisor.setFloatingButtonMinimizedState(true)
        this.setFloatingButtonStatus(true)
      }
      this.removeModalOpenClass()
      this.setWhiteLabelStatus(false)
      document.body.style.removeProperty('overflow')
      document.getElementsByTagName('html')[0].style.removeProperty('overflow')
    },
    onFaClose() {
      this.setWhiteLabelStatus(false)
      document.body.style.removeProperty('overflow')
      document.getElementsByTagName('html')[0].style.removeProperty('overflow')
      FrameAdvisor.setFrameAdvisorInitializedStatus(false)
      this.removeModalOpenClass()
      this.whiteLabelWidget.closeApp()
    },
    removeModalOpenClass() {
      const body = document.body
      const FA_MODAL_BODY_OPEN = 'fa__modal-body-open'

      if (body.classList.contains(FA_MODAL_BODY_OPEN)) {
        body.classList.remove(FA_MODAL_BODY_OPEN)
      }
    },
    registerFrameGeniusEvents() {
      document.body.addEventListener('fa-maximize', this.onFaMaximise)
      document.body.addEventListener('fa-minimize', this.onFaMinimise)
      document.body.addEventListener('fa-close', this.onFaClose)
    },
    updateWindowInnerHeight() {
      this.windowInnerHeight = window.innerHeight
    },
    updateVhMainVar() {
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vhmain', `${vh}px`)
    },
  },
}
